function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAnalyticsChart = function SvgAnalyticsChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M5.40348 12.2434H3.16253C2.54371 12.2434 2.04205 12.7451 2.04205 13.3639V21.8795C2.04205 22.4984 2.54371 23 3.16253 23H5.40348C6.02231 23 6.52396 22.4984 6.52396 21.8795V13.3639C6.52396 12.7451 6.02231 12.2434 5.40348 12.2434Z",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M13.471 9.55426H11.23C10.6112 9.55426 10.1096 10.0559 10.1096 10.6747V21.8795C10.1096 22.4983 10.6112 23 11.23 23H13.471C14.0898 23 14.5915 22.4983 14.5915 21.8795V10.6747C14.5915 10.0559 14.0898 9.55426 13.471 9.55426Z",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M21.5181 5.96875H19.2772C18.6583 5.96875 18.1567 6.4704 18.1567 7.08923V21.8795C18.1567 22.4983 18.6583 23 19.2772 23H21.5181C22.1369 23 22.6386 22.4983 22.6386 21.8795V7.08923C22.6386 6.4704 22.1369 5.96875 21.5181 5.96875Z",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalyticsChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics-chart.60773c90.svg";
export { ForwardRef as ReactComponent };